const createColumns = () => {
  const columns = {
    specialName: {
      label: 'Special',
      visible: true,
      order: 0,
      filterable: false,
      sortable: false,
      minWidth: 300,
    },
    mappedTo: {
      label: 'Mapped to',
      visible: true,
      order: 1,
      filterable: false,
      sortable: false,
      minWidth: 220,
    },
    resultedAfter: {
      label: 'Date & Time',
      visible: true,
      order: 2,
      filterable: true,
      sortable: false,
      inputType: 'date',
      defaultValue: () => [],
      minWidth: 135,
    },
    resultingStatus: {
      label: 'Resulting status',
      visible: true,
      order: 3,
      filterable: true,
      sortable: false,
      minWidth: 150,
      inputType: 'select',
      selectionType: 'single',
      inputArgs: [
        {
          value: 'NOT_RESULTED',
          label: 'Not resulted',
        },
        {
          value: 'RESULTED',
          label: 'Resulted',
        },
      ],
      defaultValue: () => 'NOT_RESULTED',
    },
    selections: {
      label: 'Selections',
      visible: true,
      order: 4,
      filterable: false,
      sortable: false,
      minWidth: 200,
    },
    actions: {
      label: '',
      visible: true,
      untoggleable: true,
      order: 5,
      filterable: false,
      nonResizable: true,
      minWidth: 120,
    },
    offeringStatus: {
      label: 'Suspended',
      visible: false,
      filterable: true,
      inputType: 'select',
      selectionType: 'single',
      untoggleable: true,
      inputArgs: [
        {
          value: 'no',
          label: 'Not suspended',
        },
        {
          value: 'yes',
          label: 'Suspended',
        },
      ],
    },
  };

  return columns;
};

export default {
  createColumns,
};

export { createColumns };
